import { getClient } from "../useMeasure"
import { toClientRect } from "./rect-utils"
import getScrollParent from "./getScrollParent"
import getScroll from "./getScroll"

const getRelativeRect = (element: HTMLElement) => {
  const rect = getClient(element)
  const scrollParent = getScrollParent(element)
  const scroll = getScroll(scrollParent)

  return toClientRect({
    top: rect.top + scroll.scrollTop,
    left: rect.left + scroll.scrollLeft,
    height: rect.height,
    width: rect.width
  })
}

export default getRelativeRect
